export enum RoleEmployee {
  CompanyAdmin = 'companyAdmin',
  SalesEmployee = 'salesEmployee',
  SalesEmployeeReadonly = 'salesEmployeeReadonly',
  CompanyAdminReadonly = 'companyAdminReadonly'
}

export const RoleEmployeeLabel = new Map<RoleEmployee, string>([
  [RoleEmployee.CompanyAdmin, 'Company Admin'],
  [RoleEmployee.SalesEmployee, 'Sales Employee'],
  [RoleEmployee.SalesEmployeeReadonly, 'Sales Employee Read-Only'],
  [RoleEmployee.CompanyAdminReadonly, 'Company Admin Read-Only']
]);
